export default __webpack_public_path__ + "static/media/typeVan.9969b021.svg";